import { API_BASE, getImageUrl } from 'config/api';

const publicUrl = typeof process.env.PUBLIC_URL === 'string' ? process.env.PUBLIC_URL : '';

export const STATIC_BROCHURE_URLS = {
    pdf: `${publicUrl}/brochures/stateelite-services.pdf`,
    doc: `${publicUrl}/brochures/stateelite-services.doc`
};

export const resolveBrochureUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    return getImageUrl(path.replace(/^\//, '')) || `${publicUrl}${path.startsWith('/') ? path : `/${path}`}`;
};

export async function fetchBrochureUrls() {
    try {
        const res = await fetch(`${API_BASE}/brochures`);
        const files = await res.json();
        if (!Array.isArray(files) || !files.length) {
            return { ...STATIC_BROCHURE_URLS };
        }

        const pdf = files.find((file) => /\.pdf$/i.test(file.name));
        const doc = files.find((file) => /\.(doc|docx)$/i.test(file.name));

        return {
            pdf: pdf ? resolveBrochureUrl(pdf.url) : STATIC_BROCHURE_URLS.pdf,
            doc: doc ? resolveBrochureUrl(doc.url) : STATIC_BROCHURE_URLS.doc
        };
    } catch (e) {
        return { ...STATIC_BROCHURE_URLS };
    }
}
